import { useContext } from "react";
import { TUserContextType, UserContext } from "./UserContext";

export const useUser = (): TUserContextType => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }

  return context;
};
